import { useState } from 'react'
import { useLanguage } from '@/i18n/LanguageContext'
import { Puzzle, Send, List, Settings, Download, Search, Map } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { ProfileSidebar } from './ProfileSidebar'
import { PostarTab } from './PostarTab'
import { FilaTab } from './FilaTab'
import { ConfigTab } from './ConfigTab'
import { ExtractorTab } from './ExtractorTab'
import { MapaTab } from './MapaTab'

export function Extension() {
  const { t } = useLanguage()
  const [selectedProfileIds, setSelectedProfileIds] = useState<string[]>([])

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-primary/20 to-primary/5">
            <Puzzle className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h1 className="text-xl font-bold tracking-tight">{t('Extensao FB')}</h1>
            <p className="text-xs text-muted-foreground">{t('Gerencie perfis, grupos e posts via extensao')}</p>
          </div>
        </div>
        <a href="/blissf-extension.zip" download>
          <Button variant="outline" size="sm" className="gap-1.5 rounded-lg border-border/40">
            <Download className="h-4 w-4" />
            {t('Baixar Extensao')} v2.3.1
          </Button>
        </a>
      </div>

      {/* Two-panel layout */}
      <div className="flex gap-6 items-start">
        {/* Sidebar */}
        <div className="w-[320px] shrink-0">
          <ProfileSidebar
            selectedProfileIds={selectedProfileIds}
            onSelectionChange={setSelectedProfileIds}
          />
        </div>

        {/* Main panel */}
        <div className="flex-1 min-w-0">
          <Tabs defaultValue="postar">
            <div className="rounded-2xl bg-muted/40 p-1 backdrop-blur-sm inline-flex">
              <TabsList className="bg-transparent gap-0.5 h-auto p-0">
                <TabsTrigger value="postar" className="rounded-xl data-[state=active]:bg-card text-xs px-3 py-1.5 transition-all duration-200">
                  <Send className="h-3.5 w-3.5 mr-1.5" />{t('Postar')}
                </TabsTrigger>
                <TabsTrigger value="fila" className="rounded-xl data-[state=active]:bg-card text-xs px-3 py-1.5 transition-all duration-200">
                  <List className="h-3.5 w-3.5 mr-1.5" />{t('Fila')}
                </TabsTrigger>
                <TabsTrigger value="config" className="rounded-xl data-[state=active]:bg-card text-xs px-3 py-1.5 transition-all duration-200">
                  <Settings className="h-3.5 w-3.5 mr-1.5" />{t('Config')}
                </TabsTrigger>
                <TabsTrigger value="extrator" className="rounded-xl data-[state=active]:bg-card text-xs px-3 py-1.5 transition-all duration-200">
                  <Search className="h-3.5 w-3.5 mr-1.5" />{t('Extrator')}
                </TabsTrigger>
                <TabsTrigger value="mapa" className="rounded-xl data-[state=active]:bg-card text-xs px-3 py-1.5 transition-all duration-200">
                  <Map className="h-3.5 w-3.5 mr-1.5" />{t('Mapa')}
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value="postar" className="mt-4">
              <PostarTab selectedProfileIds={selectedProfileIds} />
            </TabsContent>
            <TabsContent value="fila" className="mt-4">
              <FilaTab />
            </TabsContent>
            <TabsContent value="config" className="mt-4">
              <ConfigTab />
            </TabsContent>
            <TabsContent value="extrator" className="mt-4">
              <ExtractorTab selectedProfileIds={selectedProfileIds} />
            </TabsContent>
            <TabsContent value="mapa" className="mt-4">
              <MapaTab selectedProfileIds={selectedProfileIds} />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  )
}
